import { render, staticRenderFns } from "./dyTransfer.vue?vue&type=template&id=88b2837a&scoped=true&"
import script from "./dyTransfer.vue?vue&type=script&lang=js&"
export * from "./dyTransfer.vue?vue&type=script&lang=js&"
import style0 from "./dyTransfer.vue?vue&type=style&index=0&id=88b2837a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b2837a",
  null
  
)

export default component.exports